<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('BackgroundOperationrecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select ref="paramOuSelect" v-model="formInline.ouName" style="width:auto" :placeholder="$t('peaseSelect')" :popper-append-to-body="false" @change="changeParamOu" clearable @visible-change="visibleChange">
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree ref="paramOuTree" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :data="ouList" :props="defaultProps" @node-click="selectParamOu">
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('loginUserName')">
            <el-input v-model="formInline.loginUserName" clearable :placeholder="$t('loginUserName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('operationType')">
            <el-select
              v-model="formInline.operation"
              value-key="propertyKey"
              clearable
              :placeholder="$t('operationType')"
              @change="_getChildOperts"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item of fileType"
                :key="item.propertyKey"
                :label="$t(item.propertyValue)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('operationEvent')">
            <el-select
              v-model="formInline.childOperation"
              clearable
              :placeholder="$t('operationEvent')"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item of childOperats"
                :key="item.propertyValue"
                :label="$t(item.description)"
                :value="item.propertyValue"
              ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker
              v-model="formInline.logDateBegin"
              :placeholder="$t('startDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker
              v-model="formInline.logDateEnd"
              :placeholder="$t('endDate')"
              type="date"
              value-format="yyyy-MM-dd"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('operationUserName')">
            <el-input v-model="formInline.remoteUserName" clearable :placeholder="$t('operationUserName')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button
              type="primary"
              class="serachBtn letter_delet"
              @click="handleDelet"
              v-preventReClick="1000"
              v-has="'sys:new:setting:log:data:delete'"
              >{{ $t('batchDelete') }}</el-button
            >
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table组件 -->
        <Table
        v-loading="loading"
          :data="tableData"
          :tableHeight="640"
          :columns="columns"
          :operation="dateOperation"
          :type="type"
          @getList="getList"
          @operate="operationEvent"
          :currentPage="currentPage"
          :pageSize="pageSize"
          ref="tanleAssembly"
          :operationWidth="100"
          @sortChange="handleSort"
        ></Table>
        <!-- 页脚 -->
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { getOperations, deleteOperationLog } from '@/api/log'
import { getOPERATION, operationMap } from '@/api/setting'
import { getOus } from '@/api/UserList'
import { getExportOperations } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  data() {
    return {
      formInline: {
        ouName: '',
        ouId: '',
        //查询表单字段
        loginUserName: '',
        remoteUserName: '',
        logDateBegin: beforeWeekDate(),
        logDateEnd: nowDate(),
        operation: { propertyValue: '', propertyKey: '' },
        childOperation: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      fileType: [],
      childOperats: [],
      childoperationMap: [],
      // 用于批量删除 公共组件类型判断
      type: 'operation',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      ouList: [],
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        operation: this.formInline.operation.propertyValue,
        loginUserName: this.formInline.loginUserName,
        remoteUserName: this.formInline.remoteUserName,
        childOperation: this.formInline.childOperation,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportOperations(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('BackgroundOperationrecord') + '.xls')
      })
    },
     // 排序
     handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc =  data.order=== "descending" ? 0 : 1
      this.getList()
    },
     // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then((res) => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._deleteOperationLog(row)
      }
    },
    //  删除后台操作日志
    _deleteOperationLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          id: row.value.id,
        }
        deleteOperationLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
            this.getList()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this._getOperations()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this._getOperations()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.logDateBegin, this.formInline.logDateEnd)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this._getOperations()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this._getOperations()
      }
    },
    // 获取操作数据
    _getOperations() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        operation: this.formInline.operation.propertyValue,
        loginUserName: this.formInline.loginUserName,
        remoteUserName: this.formInline.remoteUserName,
        childOperation: this.formInline.childOperation,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getOperations(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          for (let item of res.value.list) {
            if (this.childoperationMap[item.childOperation]) {
              item.childOperation = this.childoperationMap[item.childOperation]
            }
          }
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    // 基础配置数据
    basicConfig() {
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'loginUserName',
          label: this.$t('loginUserName'),
          sort: 'loginUserName',
        },
        {
          attrName: 'operationIp',
          label: this.$t('loginUserIP'),
          sort: 'operationIp',
        },
        {
          attrName: 'remoteUserName',
          label: this.$t('operationUserName'),
          sort: 'remoteUserName',
        },
        {
          attrName: 'operation',
          label: this.$t('operationType'),
          i18n: true,
          sort: 'operation',
        },
        {
          attrName: 'childOperation',
          label: this.$t('operationEvent'),
          i18n: true,
          sort: 'childOperation',
        },
        {
          attrName: 'eventFmt',
          label: this.$t('eventH'),
          i18n: true,
          width: '100',
          align: 'center',
          sort: 'event',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          width: '180',
          align: 'center',
          sort: 'logTimestamp',
        },
      ]
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 获取后台操作类型
    _getOperationsType() {
      let param = { id: 'OPERATION' } // 传值：表名
      getOPERATION(param).then(res => {
        if (res.state === 0) {
          this.fileType = res.value
        }
      })
    },
    // 获取具体操作类型
    _getChildOperts(data) {
      // console.log(data,"data")
      this.childOperats = []
      this.formInline.childOperation = ''
      // 截取获得请求字段
      let field = data.propertyKey.split('_')
      let key = field[1] + '_' + field[2]

      let param = { id: key } // 传值：表名
      getOPERATION(param).then(res => {
        if (res.state === 0) {
          this.childOperats = res.data
        }
      })
    },
    // 获取所有子操作类型
    getOperationMap() {
      this.childoperationMap = []
      operationMap().then(res => {
        if (res.state === 0) {
          this.childoperationMap = res.data
          this._getOperations()
        }
      })
    },
  },
  created() {
    this.getOperationMap()
    this.basicConfig()
    this._getOperationsType()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 640px!important
  min-height 500px!important;/* no */
  overflow: auto
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
>>>.el-popper
 min-width 100%!important
.letter_delet
  margin-left: 10px
.bg-contain .common-table-cnt /deep/ .el-table {
  height: 585px !important
}
.common-blue-contain
  .el-pagination
    margin-top 15px
</style>
